import i18n from "@/utils/i18n";
import { defineStore } from "pinia";
import { useActiveStore as active } from "./active";
import { usePvwStore as pvw } from "./pvw";

import Maps from "./colorMaps.json";
const localPresets: any = localStorage.getItem("userColorPresets");
const localFixedPresets: any = localStorage.getItem("userFixedPresets");

const fixedLocal = localFixedPresets != null ? JSON.parse(localFixedPresets) : [];
const colorLocal = localPresets != null ? JSON.parse(localPresets) : [];
export const usePresetsStore = defineStore("presetsStore", {
	state: () =>
		({
			colorScale: {} as any,
			presetImages: {},
			colorPresets: [
				// Add default color scales here
				...Maps,
				...colorLocal
				// ...JSON.parse(localPresets.toString()).filter((item: any)=>item.type == null)
			],
			fixedColorPresets: [
				{
					id: i18n.global.t("ssa.displayPane.colorGeneral.newFixedGradient"),
					rgbPoints: [
						25, 1, 1, 1, 50, 1, 1, 1, 50, 1, 0, 0, 100, 1, 0, 0, 100, 0, 0, 1, 255, 0,
						0, 1
					],
					value: i18n.global.t("ssa.displayPane.colorGeneral.newFixedGradient"),
					text: i18n.global.t("ssa.displayPane.colorGeneral.newFixedGradient"),
					type: "fixed",
					annotations: ["37.5", "white", "75", "red", "177.5", "blue"]
				},
				...fixedLocal
				// ...JSON.parse(localPresets.toString()).filter((item: any)=>item.type == 'fixed')
			]
		}) as any,
	getters: {
		SSA_PRESETS_IMAGES(): any {
			return this.presetImages;
		},
		SSA_PRESETS_ITEMS(): any {
			return [...this.colorPresets, ...this.fixedColorPresets];
		},
		// // Helper
		SSA_FIELD_TITLE_GET(): any {
			const fieldsList = active().SSA_ACTIVE_COLORBY_FIELDS;
			// needs re-implementation (as with SSA_ACTIVE_COLORBY_FIELDS)
			return (name: any) => {
				const field = fieldsList && fieldsList.find((a: any) => a.value === name);
				return (field && field.text) || name;
			};
		},
		SSA_FIELD_COLUMN_GET(): any {
			const fieldsList = active().SSA_ACTIVE_COLORBY_FIELDS;
			// needs re-implementation
			return (name: any) => {
				const field = fieldsList && fieldsList.find((a: any) => a.value === name);
				return (field && field.column) || name;
			};
		}
	},
	actions: {
		SSA_DELETE_COLOR_PRESET(preset: any, fixed = false) {
			if (!fixed) {
				const idx = this.colorPresets.findIndex((item: any) => item.id === preset);
				if (idx >= 0) {
					this.colorPresets.splice(idx, 1);
					localStorage.setItem(
						"userColorPresets",
						JSON.stringify(
							this.colorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				}
			} else {
				const idx = this.fixedColorPresets.findIndex((item: any) => item.id === preset);
				if (idx >= 0) {
					this.fixedColorPresets.splice(idx, 1);
					localStorage.setItem(
						"userFixedPresets",
						JSON.stringify(
							this.fixedColorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				}
			}
		},
		SSA_SAVE_COLOR_PRESET(preset: any, fixed = false) {
			if (!fixed) {
				const idx = this.colorPresets.findIndex((item: any) => item.id == preset.id);
				if (idx >= 0) {
					this.colorPresets[idx] = preset;
					localStorage.setItem(
						"userColorPresets",
						JSON.stringify(
							this.colorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				} else {
					this.colorPresets.push(preset);
					localStorage.setItem(
						"userColorPresets",
						JSON.stringify(
							this.colorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				}
			} else {
				const idx = this.fixedColorPresets.findIndex((item: any) => item.id == preset.id);
				if (idx >= 0) {
					this.fixedColorPresets[idx] = preset;
					localStorage.setItem(
						"userFixedPresets",
						JSON.stringify(
							this.fixedColorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				} else {
					this.fixedColorPresets.push(preset);
					localStorage.setItem(
						"userFixedPresets",
						JSON.stringify(
							this.fixedColorPresets.filter(
								(item: any) => (item.id.match(/-/g) || []).length >= 3
							)
						)
					);
				}
			}
			this.colorScale = preset;
		},
		SSA_SET_COLOR_SCALE(scale: any) {
			this.colorScale = scale;
		},
		SSA_PRESETS_FETCH({ presetName, invert }: { presetName: string; invert: any }): any {
			const key = `${invert ? "invert_" : ""}${presetName}`;
			if (this.presetImages[key]) {
				return Promise.resolve(this.presetImages[key]);
			}
			this.presetImages[key] = { loading: true };
			return pvw()
				.PVW_FETCH_PRESET_IMAGE({ presetName, invert })
				.then(
					({
						encodedImage,
						minColor,
						maxColor
					}: {
						encodedImage: any;
						minColor: any;
						maxColor: any;
					}) => {
						const image = new Image();
						image.src = `data:image/jpg;base64,${encodedImage}`;
						this.presetImages[key] = {
							presetName,
							invert,
							image,
							minColor: `rgb(${minColor[0]},${minColor[1]},${minColor[2]})`,
							maxColor: `rgb(${maxColor[0]},${maxColor[1]},${maxColor[2]})`,
							loading: image.complete
						};
						image.addEventListener("load", () => {
							this.presetImages[key].loading = false;
						});
					}
				)
				.catch((error: any) => {
					console.error(presetName, error);
				});
		}
	}
});
